import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Box, ThemeProvider } from "@mui/material";
import ContentBox from "src/components/ContentBox/ContentBox";
import MainButton from "src/components/buttons/mainbutton";
import theme from "src/styles/mainstyle";
import invite_friends from "src/media/invite_friends.jpg";

export default function InviteFriends() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ pb: 5 }}>
        <ContentBox title="" id={"how-it-works"}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                sx={{ fontWeight: "bold", marginBottom: "20px" }}
              >
                Invite a friend
              </Typography>
              <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
                Do you like HomeSwap and our community? Feel free to invite your
                friends and let our community grow. Who can't miss traveling
                with us?
              </Typography>
              <Grid item xs={12} md={4} sx={{ pt: 4 }}>
                <MainButton
                  text="Invite!"
                  onClick={() => {
                    window.location.href =
                      "mailto:?subject=Join%20HomeSwap!&body=Come%20join%20HomeSwap%20at%20https://internationalhomeswap.com/ !";
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <div
                style={{
                  position: "relative",
                  paddingBottom: "56.25%",
                  height: 0,
                  overflow: "hidden",
                  maxWidth: "100%",
                }}
              >
                <img
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover", // Ensure the image covers the container while maintaining aspect ratio
                    borderRadius: "12px",
                  }}
                  src={invite_friends} // Replace with the URL of your image
                  alt="Invite your friends to join HomeSwap and explore the world together!"
                />
              </div>
            </Grid>
          </Grid>
        </ContentBox>
      </Box>
    </ThemeProvider>
  );
}
